import classNames from 'classnames';
import React from 'react';

import { zeroPad } from '../../../ZeroPad';

interface BankIdSessionIndicatorProps {
    durationToExpiry?: Duration;
    redBackgroundMinutesThreshold: number;
}

export const BankIdSessionIndicatorTimer = (props: BankIdSessionIndicatorProps) => {
    return (
        <>
            {props.durationToExpiry !== undefined && (
                <div
                    className={classNames(
                        'BankIdSessionIndicatorTimer__Wrapper',
                        props.durationToExpiry.minutes !== undefined &&
                            props.durationToExpiry!.minutes < props.redBackgroundMinutesThreshold &&
                            'BankIdSessionIndicatorTimer__Wrapper--Red'
                    )}
                >
                    <div className="BankIdSessionIndicatorTimer__TimeLeftText">
                        {zeroPad(props.durationToExpiry!.minutes)}:{zeroPad(props.durationToExpiry!.seconds)}
                    </div>
                </div>
            )}
        </>
    );
};
